<template>
  <div class="car-message-display">
    <div class="tekbox-content" :class=" details.color + '-border'">
      <span class="tekbox-heading">
        <span class="fa" :class=" details.icon + ' ' +  details.color"></span>
        {{ details.action }}
      </span>
      <p class="grey"><span class="fa fa-calendar-alt fa-fw"></span> {{ date | date_format }}</p>
      <p>{{ details.description }}</p>
      <p v-if="reservationId">
        Reservation #{{ reservationId }}
      </p>
      <div class="tekbox-status-bar row">
        <div class="col-sm-8">
        </div>
        <div class="col-sm-4" v-if="location.lat && location.lng">
          <span class="fa fa-fw fa-crosshairs"></span>
          <span class="small">GPS Available</span>
        </div>
        <div class="col-sm-4" v-else>
          <span class="fa fa-fw fa-ban"></span>
          <span class="small">No GPS Available</span>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-8">
          <button class="btn btn-xs btn-dark" type="button" @click="$refs.rawMessage.style.display == 'none' ? viewRawMessage() : hideRawMessage()">
            <span class="fa fa-code fa-fw"></span> Show Raw Message
          </button>
        </div>
        <div class="col-sm-4">
          <template v-if="location.lat && location.lng">
            <a target="_blank" class="btn btn-xs btn-info" :href="googleMaps">
              <span class="fa fa-globe"></span> View Location
            </a>
          </template>
        </div>
      </div>
      <pre style="display: none;" ref="rawMessage" class="raw-message">
        <button type="button" class="close" aria-label="Close" @click="hideRawMessage()">
          <span aria-hidden="true">&times;</span>
        </button>
        {{ data.rawMessage }}
      </pre>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CarMessageDisplay',
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    googleMaps () {
      return 'https://maps.google.com/?q=' +
      this.location.lat + ',' + this.location.lng
    },
    date () {
      if (this.data.rawMessage['ns2:Body'] && this.data.rawMessage['ns2:Body'].SBP12SendReservationToVehicle) {
        return this.data.rawMessage['ns2:Body'].SBP12SendReservationToVehicle.MsgToVehicleRequestData.TimeStampBookingSys
      } else if (this.data.rawMessage['ns2:Body'] && this.data.rawMessage['ns2:Body'].SBP10SendRemoteFunctionToVehicle) {
        return this.data.rawMessage['ns2:Body'].SBP10SendRemoteFunctionToVehicle.MsgToVehicleRequestData.TimeStampBookingSys
      } else {
        return this.data.rawMessage.MsgFromVehicleRequestData ? this.data.rawMessage.MsgFromVehicleRequestData.TimeStampCComD : new Date()
      }
    },
    location () {
      let loc = { lat: 0, lng: 0 }
      if (this.data.rawMessage.MsgFromVehicleRequestData &&
        this.data.rawMessage.MsgFromVehicleRequestData.VehicleInformation &&
        this.data.rawMessage.MsgFromVehicleRequestData.VehicleInformation.GPSData) {
        loc.lat = this.data.rawMessage.MsgFromVehicleRequestData.VehicleInformation.GPSData.Latitude
        loc.lng = this.data.rawMessage.MsgFromVehicleRequestData.VehicleInformation.GPSData.Longitude
      }
      return loc
    },
    reservationId () {
      if (this.data.rawMessage.Tripdata) {
        return this.data.rawMessage.Tripdata.ReservationID
      } else if (this.data.rawMessage.Identification) {
        return this.data.rawMessage.Identification.ReservationID
      } else if (this.data.rawMessage['ns2:Body'] && this.data.rawMessage['ns2:Body'].SBP12SendReservationToVehicle) {
        if (this.data.message.indexOf('valet') !== -1) {
          return null
        } else {
          return this.data.rawMessage['ns2:Body'].SBP12SendReservationToVehicle.ReservationID
        }
      } else {
        return null
      }
    },
    details () {
      let deets = {
        action: 'Unkown message type',
        icon: 'question-circle',
        description: '',
        color: ''
      }
      if (this.data.rawMessage.RemoteFunctionNo) {
        deets.action = 'Vehicle Command Action'
        deets.icon = 'fa-external-link-square-alt'
        switch (this.data.rawMessage.FunctionState.StateNo) {
          case '201':
            deets.description = 'Vehicle Command valid, will send to vehicle soon'
            break
          case '202':
            deets.description = 'Vehicle Command valid, will send to vehicle urgently'
            break
          case '203':
            deets.description = 'Vehicle Command sent, awaiting acknowledgement'
            break
          case '204':
            deets.description = 'Vehicle Command sent, acknowledgement not supported'
            break
          case '205':
            deets.description = 'Vehicle Command received by vehicle'
            break
          case '206':
            deets.description = 'Vehicle Command executed correctly'
            break
          case '210':
            deets.description = 'Could not send Vehicle Command, NPort is down'
            break
          case '211':
            deets.description = 'Vehicle Command failed: ' + this.data.rawMessage.FunctionState.Message
            break
          default:
            deets.description = 'No matching description found'
            break
        }
        switch (this.data.rawMessage.RemoteFunctionNo) {
          case '1':
            deets.color = 'purple'
            deets.icon = 'fa-sign-in-alt'
            deets.action = 'Instant Reservation Created'
            break
          case '10':
            deets.icon = 'fa-globe'
            deets.action = 'Returning GPS Location'
            deets.color = 'yellow'
            break
          case '9':
            deets.icon = 'fa-ban'
            deets.action = 'Cancelling a Started Reservation'
            deets.color = 'red'
            break
          case '16':
            deets.icon = 'fa-lock'
            deets.action = 'Locking and Logging out of Car'
            deets.color = 'amber'
            break
          case '19':
            deets.icon = 'fa-unlock'
            deets.action = 'Unlocking and Logging in of Car'
            deets.color = 'pink'
            break
        }
      } else if (this.data.rawMessage.Tripdata) {
        deets.icon = 'fa-download'
        deets.action = `Reservation #${this.data.rawMessage.Tripdata.ReservationID} completed`
        deets.color = 'green'
      } else if (this.data.rawMessage.Identification) {
        deets.icon = 'fa-sign-in-alt'
        deets.action = `User logged into Reservation #${this.data.rawMessage.Identification.ReservationID}`
        deets.color = ''
      } else if (this.data.rawMessage.JobProcessingState) {
        deets.action = 'Reservation Request'
        switch (this.data.rawMessage.JobProcessingState.StateNo) {
          case '201':
            deets.description = 'Vehicle Command valid, will send to vehicle soon'
            break
          case '202':
            deets.description = 'Vehicle Command valid, will send to vehicle urgently'
            break
          case '203':
            deets.description = 'Vehicle Command sent, awaiting acknowledgement'
            deets.icon = 'fa-paper-plane'
            break
          case '204':
            deets.description = 'Vehicle Command sent, acknowledgement not supported'
            break
          case '205':
            deets.icon = 'fa-check'
            deets.description = 'Vehicle Command received by vehicle'
            deets.color = 'green'
            break
          case '206':
            deets.icon = 'fa-check'
            deets.description = 'Vehicle Command executed correctly'
            deets.color = 'green'
            break
          case '210':
            deets.icon = 'fa-exclamation-triangle'
            deets.description = 'Could not send Vehicle Command, NPort is down'
            deets.color = 'red'
            break
          case '211':
            deets.icon = 'fa-exclamation-triangle'
            deets.description = `Vehicle Command failed: ${this.data.rawMessage.FunctionState.Message}`
            deets.color = 'red'
            break
          case '214':
            deets.icon = 'fa-sync'
            deets.description = 'Vehicle Command received, awaiting vehicle response'
            deets.color = 'yellow'
            break
          case '215':
            deets.icon = 'fa-clock'
            deets.description = 'Timeout. No response from OBS received'
            deets.color = 'red'
            break
          default:
            deets.description = 'No matching description found'
            break
        }
      } else if (this.data.rawMessage['ns2:Body'] && this.data.rawMessage['ns2:Body'].SBP10SendRemoteFunctionToVehicle) {
        switch (this.data.rawMessage['ns2:Body'].SBP10SendRemoteFunctionToVehicle.RemoteFunctionNo) {
          case 1:
            deets.icon = 'fa-sign-in-alt'
            deets.action = 'Creating Instant Reservation'
            deets.color = 'purple'
            break
          case 3:
            if (this.data.message.indexOf('Unlock') !== -1) {
              deets.icon = 'fa-unlock'
              deets.action = 'Remote Unlock Vehicle'
              deets.color = 'pink'
              break
            } else {
              deets.icon = 'fa-lock'
              deets.action = 'Remote Lock Vehicle'
              deets.color = 'amber'
              break
            }
          case 4:
            if (this.data.message.indexOf('Unlock') !== -1) {
              deets.icon = 'fa-unlock'
              deets.action = 'Remote Unlock Vehicle'
              deets.color = 'pink'
              break
            } else {
              deets.icon = 'fa-lock'
              deets.action = 'Remote Lock Vehicle'
              deets.color = 'amber'
              break
            }
          case 10:
            deets.icon = 'fa-globe'
            deets.action = 'Requesting GPS Location'
            deets.color = 'yellow'
            break
          case 7:
            deets.icon = 'fa-hand-paper'
            deets.action = 'Immobilize Vehicle'
            deets.color = 'red'
            break
          case 9:
            deets.icon = 'fa-ban'
            deets.action = 'Cancelling Current Reservation'
            deets.color = 'red'
            break
          case 16:
            deets.icon = 'fa-lock'
            deets.action = 'Locking and Logging out of Car'
            deets.color = 'amber'
            break
          case 19:
            deets.icon = 'fa-unlock'
            deets.action = 'Unlocking and Logging in of Car'
            deets.color = 'pink'
            break
        }
      } else if (this.data.rawMessage['ns2:Body'] && this.data.rawMessage['ns2:Body'].SBP12SendReservationToVehicle) {
        let dateFormat = 'ddd, MMM Do YYYY, h:mma zz'
        let msg = this.data.rawMessage['ns2:Body'].SBP12SendReservationToVehicle
        if (this.data.message.indexOf('valet') !== -1) {
          deets.description = `${moment(msg.StartDateTime).format(dateFormat)} to ${moment(msg.EndDateTime).format(dateFormat)}`
          deets.action = this.data.message
          deets.icon = 'fa-user'
        } else if (this.data.message.indexOf('Changing') !== -1) {
          deets.description = `${moment(msg.StartDateTime).format(dateFormat)} to ${moment(msg.EndDateTime).format(dateFormat)}`
          deets.action = 'Booking changed to this vehicle from another'
          deets.icon = 'fa-car'
          deets.color = 'amber'
        } else if (msg.Index > 0) {
          deets.description = `Reservation Modified to: ${moment(msg.StartDateTime).format(dateFormat)} to ${moment(msg.EndDateTime).format(dateFormat)}`
          deets.action = `Modifying Reservation #${msg.ReservationID}`
          deets.icon = 'fa-calendar-alt'
          deets.color = 'purple'
        } else {
          deets.description = `Reservation Created: ${moment(msg.StartDateTime).format(dateFormat)} to ${moment(msg.EndDateTime).format(dateFormat)}`
          deets.action = `Creating Reservation #${msg.ReservationID}`
          deets.icon = 'fa-calendar-plus'
          deets.color = 'green'
        }
        if (msg.ReservationType === 6) {
          deets.description = `User with Chip ID ${msg.Customer['ns3:ChipPersID']} cancelled reservation`
          deets.action = `Cancelling Unused Reservation #${msg.ReservationID}`
          deets.icon = 'fa-ban'
          deets.color = 'red'
        }
        if (this.data.message === 'Reservation Resend') {
          deets.description = `Reservation resent to Vehicle (Tech Push): ${moment(msg.StartDateTime).format(dateFormat)} to ${moment(msg.EndDateTime).format(dateFormat)}`
          deets.action = 'Reservation Resend'
          deets.icon = 'fa-cloud-upload-alt'
          deets.color = 'pink'
        }
        if (this.data.message === 'Tech Push') {
          deets.description = `Reservation resent to Vehicle (Tech Push): ${moment(msg.StartDateTime).format(dateFormat)} to ${moment(msg.EndDateTime).format(dateFormat)}`
          deets.action = 'Reservation Resend'
          deets.icon = 'fa-cloud-upload-alt'
          deets.color = 'pink'
        }
      } else if (this.data.rawMessage.Alarm) {
        deets.action = 'Alarm ' + this.data.rawMessage.Alarm.AlarmNo
        switch (this.data.rawMessage.Alarm.AlarmNo) {
          case '77':
            deets.description = 'Reset after main task hang up'
            deets.icon = 'fa-exclamation-triangle'
            deets.color = 'red'
            break
          case '80':
            deets.action = 'Box Restart'
            deets.description = 'Restart after power outage'
            deets.icon = 'fa-bolt'
            deets.color = 'red'
            break
          case '81':
            deets.action = 'Flat Battery'
            deets.description = 'Unit restarted after empty battery'
            deets.icon = 'fa-battery-empty'
            deets.color = 'red'
            break
          case '85':
            deets.action = 'Low Battery'
            deets.description = 'Warning. Battery is almost empty'
            deets.icon = 'fa-battery-quarter'
            deets.color = 'red'
            break
          case '127':
            deets.description = 'Card Swiped on Vehicle'
            deets.icon = 'fa-credit-card'
            deets.color = 'purple'
            break
          case '123':
            deets.description = 'Ignition turned off'
            deets.icon = 'fa-minus-circle'
            deets.color = 'yellow'
            break
          case '122':
            deets.description = 'Ignition turned on'
            deets.icon = 'fa-power-off'
            deets.color = 'yellow'
            break
        }
      } else {
        deets.action = 'Unkown message type'
      }
      return deets
    }
  },
  methods: {
    viewRawMessage () {
      this.$refs.rawMessage.style.display = 'block'
    },
    hideRawMessage () {
      this.$refs.rawMessage.style.display = 'none'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/CarMessageDisplay.vue